<div fxLayout="row wrap">
    <span>
        {{message}}
    </span>
</div>

<div fxLayout="row wrap" fxLayoutAlign="end center" style="margin-top: 0.5rem;">
    <button 
        fxFlex="35" 
        pButton 
        type="button" 
        (click)="onReject()"
        style="margin-right: 0.5rem; height: 35px; padding-top: 0.35rem;" 
        class="dialog-button">
        <span>{{rejectLabel}}</span>
    </button>
    <button 
        fxFlex="32" pButton type="button" 
        style="height: 35px; padding-top: 0.35rem;"
        class="dialog-button" 
        (click)="onConfirm()">
        <span>{{confirmLabel}}</span>
    </button>
</div>
